module.exports = __webpack_public_path__ + "src/img/more/persistence_label.9e2a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/more/persistence_label.jpg
// module id = 117
// module chunks = 0